import { useAuthStore } from '@/stores/auth'
import axios, { type AxiosResponse } from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL,
  timeout: 5000
})

// 요청 인터셉터
api.interceptors.request.use(
  (config) => {
    const { state } = useAuthStore()
    if (state.accessToken) {
      config.headers.Authorization = `Bearer ${state.accessToken}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 응답 인터셉터
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data
  },
  async (error) => {
    const { state, getAccessToken, clearTokens } = useAuthStore()
    const originalRequest = error.config

    // 토큰 만료 시 리프레시 토큰으로 재발급
    if (error.response?.status === 401 && error.response?.data.result.code === 40100003 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        await getAccessToken()

        originalRequest.headers.Authorization = `Bearer ${state.accessToken}`
        return api(originalRequest)
      } catch (refreshError) {
        // 리프레시 토큰도 만료된 경우 로그아웃 처리
        clearTokens()
        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(error)
  }
)

export default api